import { Card, Form, Input, Select } from 'antd';
import FormItem from 'components/form/FormItem';
import RestFormUpload from 'components/rest/restFormItems/RestFormUpload';
import {
  RETURN_CHANNEL,
  RETURN_REASON,
  RETURN_SOLUTION,
} from 'constants/ordersReturn';
import { useTranslation } from 'react-i18next';

const formatHightLight = (src, values) => {
  if (values.thumbnail === src)
    return {
      color: 'var(--primary)',
      label: 'Main',
      className: 'ant-tag-primary',
    };
  if (values.secondaryThumbnail === src)
    return {
      color: 'var(--color-purple)',
      label: 'Secondary',
      className: 'ant-tag-secondary',
    };
  return null;
};

export default function ReturnInformation() {
  const { t } = useTranslation();

  return (
    <Card title={t('ordersReturn.return')} className="w-full h-full">
      <FormItem name="reason" label={t('ordersReturn.reason')} required>
        <Select placeholder={t('ordersReturn.select')}>
          {Object.values(RETURN_REASON)?.map((item, index) => (
            <Select.Option
              key={`solution-${index.toString()}`}
              value={item?.value}
            >
              {t(item?.text)}
            </Select.Option>
          ))}
        </Select>
      </FormItem>
      <Form.Item noStyle shouldUpdate={(o, n) => o.returnType !== n.returnType}>
        {({ getFieldValue }) => {
          const returnType = getFieldValue('returnType');

          if (returnType === RETURN_CHANNEL['ONLINE'].value) return <></>;

          return (
            <FormItem
              name="solution"
              label={t('ordersReturn.solution')}
              required
              initialValue={RETURN_SOLUTION['REFUND'].value}
            >
              <Select placeholder={t('ordersReturn.select')}>
                {Object.values(RETURN_SOLUTION)?.map((item, index) => (
                  <Select.Option
                    key={`solution-${index.toString()}`}
                    value={item?.value}
                  >
                    {t(item?.text)}
                  </Select.Option>
                ))}
              </Select>
            </FormItem>
          );
        }}
      </Form.Item>
      <FormItem
        name="note"
        label={t('ordersReturn.description.label')}
        placeholder={t('ordersReturn.select')}
      >
        <Input.TextArea />
      </FormItem>
      <RestFormUpload
        formatHightLight={formatHightLight}
        type="array"
        name="images"
        label={t('ordersReturn.image')}
        highlightName="avatar"
        accept="image/*,video/*"
        required
      />
    </Card>
  );
}
